import { render } from "./FormContainer.vue?vue&type=template&id=2c88d210"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=2c88d210&lang=less"

import exportComponent from "D:\\WorkSpace\\Codes\\website-apps\\frontend\\report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__